import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';

/* eslint-disable */
//const __svg__ = { path: './svg/*.svg', name: 'icons/icons.svg', filename: svgFileName };
//require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = `${process.env.WP_HOME}:${process.env.WEBPACK_PORT}/${__assetsBasePath__}`;
}

/**
 * Iterates over all DOM nodes with the "data-component" attribute
 * and dynamically imports the corresponding component modules.
 *
 * @param {Document|Element} parentNode - The parent node to search within (defaults to document)
 * @returns {void}
 */
function initComponents(parentNode = document) {
    for (const node of parentNode.querySelectorAll('[data-component]')) {
        const componentPath = ComponentHelper.prepareComponentPath(node.getAttribute('data-component'));

        if (typeof componentPath !== 'string') {
            continue; // eslint-disable-line no-continue
        }

        import(/* webpackChunkName: "[request]" */ `./components/${componentPath}`).then((Component) => {
            const comp = new Component.default(node); // eslint-disable-line new-cap
            comp.init();
        }).catch((e) => console.info(e.message, `at component: ${componentPath}`)); // eslint-disable-line no-console
    }
}

/**
 * Removes the loading class from the body element after the page has loaded.
 * This is used for controlling page transitions and animations.
 *
 * @returns {void}
 */
function removeAfterReload() {
    document.querySelector('body').classList.remove('body-remove-on-load');
}

window.$ = jQuery;

$(window).on('load', () => {
    initComponents();
    //objectFitImages();

    setTimeout(removeAfterReload, 1000);
});

/**
 * Check for hot module replacement and use it if possible.
 * This allows dynamic update of specific components during development.
 */
if (module.hot) {
    /**
     * Accept updates for FormMultipleSelect component.
     * Enables hot reloading without full page refresh.
     */
    module.hot.accept('./components/03_molecules/FormMultipleSelect/index.js', function() {
        console.log('Accepting the updated FormMultipleSelect module!');
    })

    /**
     * Accept updates for Ticker component JS.
     * Enables hot reloading of the Ticker JavaScript code.
     */
    module.hot.accept('./components/03_molecules/Ticker/index.js', function() {
        console.log('Accepting the updated ticker module!');
    })
    /**
     * Accept updates for Ticker component SCSS.
     * Enables hot reloading of the Ticker styles.
     */
    module.hot.accept('./components/03_molecules/Ticker/index.scss', function() {
        console.log('Accepting the updated ticker module!');
    })
}
